import * as Yup from 'yup';

const technicianValidation = (t: (key: string) => string) => ({
  updatePassword: Yup.object().shape({
    new_password: Yup.string().required(t('updatePassword.newPasswordRequired')),
    new_password_confirmation: Yup.string().oneOf([Yup.ref('new_password')], t('updatePassword.newPasswordConfirm')),
  }),
});

export default technicianValidation;
